import { useDndContext } from "@dnd-kit/core";
import { TreeNodeIcon } from "../views/tree-node-icon/tree-node-icon";
import { CompanyDocumentTreeDataNode } from "../model/types";

/**
 * Копия строки, которая едет за курсором, пока исходная остаётся на месте. Компактная,
 * а не во всю ширину строки, чтобы не закрывать панель уровней внизу окна.
 */
export function DragPreview() {
  const { active } = useDndContext();
  const node: CompanyDocumentTreeDataNode | undefined =
    active?.data.current?.node;

  if (!node) {
    return null;
  }

  return (
    <span className="inline-flex min-h-14 max-w-80 cursor-grabbing items-center gap-3 rounded-lg border border-[--palette-primary-3] bg-white px-5 shadow-lg">
      <TreeNodeIcon node={node.node} className="shrink-0 text-xl" />
      <span className="min-w-0 truncate text-base leading-6">{node.title}</span>
    </span>
  );
}
